import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API } from "../config";
import { Menu } from "../components/ui/menu";
import { useProfile } from "../context/ProfileContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

export default function EditUserPage() {
  const { profile, loading } = useProfile();
  const { account } = useParams();
  const [user, setUser] = useState<any>(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isHead, setIsHead] = useState<boolean>(false);
  const [sections, setSections] = useState<Array<string>>([]);
  const navigate = useNavigate();

  let rawToken = null;
  try {
    rawToken = localStorage.getItem("token");
  } catch (e) {
    console.error("Error reading token from localStorage:", e);
  }
  const token = rawToken;

  useEffect(() => {
    if (!token || !account) return;

    fetch(API.USER(String(account)), {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          setError(data.error);
          setTimeout(() => setError(""), 5000);
        } else {
          setUser(data);
        }
      }).catch((err) => {
      setError(`Помилка сервера ${err}`);
      setTimeout(() => setError(""), 5000);
    });

    fetch(API.SECTIONS, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          setError(data.error);
          setTimeout(() => setError(""), 5000);
        } else {
          if (Array.isArray(data)) {
            data.sort(new Intl.Collator('uk').compare);
          } else {
            data = [];
          }
          setSections(data);
        }
      }).catch((err) => {
      setError(`Помилка сервера ${err}`);
      setTimeout(() => setError(""), 5000);
    });
  }, [account, token]);

  const handleChange = (field: string, value: any) => {
    setUser((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleNestedChange = (group: string, field: string, value: string) => {
    setUser((prev: any) => ({
      ...prev,
      [group]: {
        ...prev[group],
        [field]: value,
      },
    }));
  };

  const handleValueChange = (group: string, field: string, value: string) => {
    const update = { ...user, [field]: [value] }
    setUser((prev: any) => ({
      ...prev,
      ...update
    }));
  };

  const handleMultipleValueChange = (field: string, target: any) => {
    const selectedOptions = Array.from(target.selectedOptions).map((option: any) => option.value);
    console.log("selectedOptions", selectedOptions);
    const update = { ...user, [field]: selectedOptions }
    setUser((prev: any) => ({
      ...prev,
      ...update
    }));
  };

  const handleSave = async () => {
    if (!token || !account) return;
    try {
      const res = await fetch(API.USER(String(account)), {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(user),
      });

      const data = await res.json();
      if (res.ok) {
        setSuccess("Успішно збережено ✅");
        setTimeout(() => setSuccess(""), 5000);
      } else {
        setError(data.error || "Не вдалося оновити");
        setTimeout(() => setError(""), 5000);
      }
    } catch (err) {
      setError(`Помилка сервера ${err}`);
      setTimeout(() => setError(""), 5000);
    }
  };

  if (loading) return <p className="text-center p-4">Завантажується...</p>;

  return (
    <Menu>

      <div className="max-w-xl p-6 bg-white shadow rounded-xl space-y-4">
        <div className="flex items-center justify-between mb-4">
          <button
            onClick={() => navigate("/users")}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-400 text-sm rounded text-white mr-4"
          >
            <FontAwesomeIcon icon={faChevronLeft} className=""/>
          </button>
          <h2 className="text-xl font-bold text-indigo-700 text-left">Редагувати користувача: {account}</h2>
        </div>

        {error && <p className="text-red-500">{error}</p>}
        {success && <p className="text-green-600">{success}</p>}

        <div>
          <label className="text-sm font-medium">ПІБ
            <input
              className="w-full px-3 py-2 rounded mt-1"
              value={user?.name || ""}
              onChange={(e) => handleChange("name", e.target.value)}
              readOnly
              disabled
            /></label>
        </div>

        <div>
          <label className="text-sm font-medium">СТ
            <input
              className="w-full px-3 py-2 rounded mt-1"
              value={user?.section || ""}
              onChange={(e) => handleChange("section", e.target.value)}
              readOnly
              disabled
            /></label>
        </div>

        <div className="w-full">
          <div className={"flex flex-col w-full grid grid-cols-1"}>
            <label className="text-sm font-medium">КОД НС2 (СИСТЕМИ)
              <input
                className="w-full px-3 py-2 rounded mt-1"
                value={user?.accounts?.prefix || ""}
                onChange={(e) => handleNestedChange("accounts", "prefix", e.target.value)}
                readOnly
                disabled
              /></label>
            <label className="text-sm font-medium">КОД НС2 (ПРИЙШОВ)
              <input
                className="w-full px-3 py-2 rounded mt-1"
                value={user?.accounts?.raw || ""}
                readOnly
                disabled
              /></label>
            <label className="text-sm font-medium">КОД НС2 (Уточнення)
              <input
                className="w-full px-3 py-2 rounded mt-1"
                value={user?.accounts?.suffix || ""}
                readOnly
                disabled
              /></label>
          </div>
        </div>

        <hr className={"border-dashed border-2 border-sky-500 divide-y ring-1 ring-green-100 ring-inset"}/>

        <div className="flex w-full">
          <div className="w-full">
            <label className="w-full block text-sm font-medium">Пароль (ОНОВИТИ) якщо пустий то не змінюється
              <input
                type="password"
                className="w-full border px-3 py-2 rounded mt-1"
                value={user?.password || ""}
                onChange={(e) => handleChange("password", e.target.value)}
                autoComplete="password"
              /></label>
          </div>
        </div>

        <div className="flex w-full">
          <div>
            <label className="w-1/2 text-sm font-medium ">Роль
              <select
                className="w-full border px-3 py-2 rounded mt-1"
                value={user?.roles?.[0] || "user"}
                onChange={(e) => handleValueChange("accounts", "roles", e.target.value)}
              >
                <option value="USER">Користувач</option>
                <option value="HEAD">Голова СТ</option>
                <option value="ADMIN">Адміністратор</option>
              </select></label>
          </div>
        </div>

        {user?.roles?.includes("HEAD") && (
          <div className="flex w-full">
            <div>
              <label className="w-1/2 text-sm font-medium ">Садове товариство
                <select
                  multiple={true}
                  className="w-full border px-3 py-2 rounded mt-1"
                  value={user?.sections || [""]}
                  onChange={(e) => handleMultipleValueChange("sections", e.target)}
                >
                  {sections.map((section) => (
                    <option key={section} value={section}>{section}</option>
                  ))}
                </select></label>
            </div>
          </div>
        )}

        <div className="flex w-full">
          <div className="flex w-full">
            <span className="text-sm font-medium">Telegram: {user?.telegram}</span>
          </div>

        </div>

        <div className="flex justify-between mt-6">
          <button
            onClick={() => navigate("/users")}
            className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-sm rounded"
          >
            Назад
          </button>

          <button
            onClick={handleSave}
            className="px-4 py-2 bg-indigo-600 text-white hover:bg-indigo-700 text-sm rounded"
          >
            Зберегти
          </button>
        </div>

        {error && <p className="text-red-500">{error}</p>}
        {success && <p className="text-green-600">{success}</p>}

      </div>
    </Menu>
  );
}
